import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastController: ToastController ) { }

  async success(msj: string, duration: number = 3000 ) {
    const toastRef = await this.toastController.create({
      message: msj,
      duration: duration,
      icon: "checkmark-circle",
      cssClass: "success-toast",
      buttons: [
        {
          icon: "close",
          role: "cancel"
        }
      ]
    });

    toastRef.present();
  }

  async error(msj: string, duration: number = 3000 ) {
    const toastRef = await this.toastController.create({
      message: msj,
      duration: duration,
      icon: "close-circle",
      cssClass: "error-toast",
      buttons: [
        {
          icon: "close",
          role: "cancel"
        }
      ]
    });

    toastRef.present();
  }
}
